module.exports = __webpack_public_path__ + "static/media/distribution-centers.ea9e381c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/distribution-centers.png
// module id = 2573
// module chunks = 0